import BoldSmallText from '@/components/BoldSmallText';
import BoldText from '@/components/BoldText';
import { openCrisp } from '@/helpers';
import { Box, Card, Icon, InlineGrid, InlineStack } from '@shopify/polaris';
import { BookIcon, LightbulbIcon, ShieldPersonIcon, StarIcon } from '@shopify/polaris-icons';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PointerDiv } from '../../styled';

export const SupportCard = () => {
  const { t } = useTranslation('dashboard');

  const supportData = useMemo(
    () => [
      {
        id: 1,
        icon: ShieldPersonIcon,
        detail: t('support.chat'),
        onClick: openCrisp,
      },
      {
        id: 2,
        icon: BookIcon,
        detail: t('support.document'),
        onClick: () => window.open('https://docs.dingdoong.io/'),
      },
      {
        id: 3,
        icon: LightbulbIcon,
        detail: t('support.feature'),
        onClick: () => window.open('https://dingdoong.canny.io/feature-requests'),
      },
      {
        id: 4,
        icon: StarIcon,
        detail: t('support.connectPM'),
        onClick: () => window.open('https://xipatcorp.sg.larksuite.com/scheduler/9d4ee2b3c8361a40'),
      },
    ],
    [t],
  );

  return (
    <Card>
      <BoldText>{t('support.title')}</BoldText>
      <Box paddingBlockStart={'300'}>
        <InlineGrid columns={{ lg: 4, md: 2, xs: 1 }} gap="300">
          {supportData.map((item) => (
            <PointerDiv isPointer key={item.id} onClick={item.onClick}>
              <Card>
                <InlineStack gap="050" align="center" blockAlign="center">
                  <Box>
                    <Icon source={item.icon} />
                  </Box>
                  <BoldSmallText>{item.detail}</BoldSmallText>
                </InlineStack>
              </Card>
            </PointerDiv>
          ))}
        </InlineGrid>
      </Box>
    </Card>
  );
};
